export default "__VITE_ASSET__DFZWCu5s__"